import styles from "./youtube-embed-modal.module.scss";
import { useMobile } from "@/hooks/use-responsive";

export interface YoutubeEmbedModalProps {
  title: string;
  desktopYoutubeVideoId: string;
  mobileYoutubeVideoId: string;
}

const YoutubeEmbedModal = ({
  title,
  desktopYoutubeVideoId,
  mobileYoutubeVideoId,
}: YoutubeEmbedModalProps) => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.embed_wrapper}>
      <h1>{title}</h1>
      <iframe
        className={styles.iframe}
        loading={"lazy"}
        frameBorder="0"
        allowFullScreen={true}
        src={`https://www.youtube.com/embed/${isMobile ? mobileYoutubeVideoId : desktopYoutubeVideoId}`}
      />
    </div>
  );
};

export default YoutubeEmbedModal;
